// Contact Partner form options
// Following DRY principle by centralizing option definitions

/**
 * Get contact type options with translations
 */
export const getContactTypeOptions = (tForms: (key: string) => string) => [
  {
    value: 'daily_business',
    label: tForms('contactPartner.contactTypes.dailyBusiness'),
  },
  {
    value: 'it',
    label: tForms('contactPartner.contactTypes.it'),
  },
  {
    value: 'invoices',
    label: tForms('contactPartner.contactTypes.invoices'),
  },
];

/**
 * Get language options with translations
 */
export const getLanguageOptions = (tForms: (key: string) => string) => [
  {
    value: 'de',
    label: tForms('contactPartner.languages.de'),
  },
  {
    value: 'en',
    label: tForms('contactPartner.languages.en'),
  },
  {
    value: 'fr',
    label: tForms('contactPartner.languages.fr'),
  },
  {
    value: 'it',
    label: tForms('contactPartner.languages.it'),
  },
];

/**
 * Get title options with translations
 */
export const getTitleOptions = (tForms: (key: string) => string) => [
  {
    value: 'Herr',
    label: tForms('contactPartner.titles.mr'),
  },
  {
    value: 'Frau',
    label: tForms('contactPartner.titles.mrs'),
  },
  {
    value: 'Dr.',
    label: tForms('contactPartner.titles.dr'),
  },
  {
    value: 'Prof.',
    label: tForms('contactPartner.titles.prof'),
  },
  {
    value: 'Prof. Dr.',
    label: tForms('contactPartner.titles.profDr'),
  },
];
